import React from 'react';
import LegalLayout from '../../components/LegalLayout';
import LegalDocBody from '../../components/LegalDocBody';

const SOURCE = `NoFee Commission-Free Restaurant Ordering Platform Customer Agreement

Terms for customers using NoFee to discover restaurants and place orders

This Customer Agreement governs your use of the NoFee platform as a customer (diner). It supplements the Terms of Service and should be read with the Privacy Policy, Cookie Policy, and Rewards Program Terms. By creating a customer Account or placing an Order, you agree to it.

Effective date: [[CONFIRM: insert date]]

1. YOUR ACCOUNT

1.1 You must be at least 18 (or the age of majority where you live) to create a customer Account. You agree to provide accurate information and to keep your Account details current. You are responsible for activity under your Account and for keeping your credentials secure.

1.2 You may create an Account with your name, email, and password, and you may add a ZIP/postal code and, when you choose to save an address or place a delivery Order, a street address. You can manage your profile, saved addresses, favorites, order history, and preferences in your account settings.

1.3 You can close your Account at any time through your settings or by contacting support. We may suspend or terminate your Account as described in the Terms of Service, including for fraud or Rewards abuse.

2. PLACING ORDERS

2.1 You buy from the Restaurant, not from NoFee. When you place an Order, you enter into a contract of sale directly with the Restaurant. NoFee facilitates the transaction but does not sell, prepare, or deliver food and is not a party to the sale.

2.2 You are responsible for reviewing your Order before submitting it, including items, customizations, add-ons, quantities, pickup or delivery selection, any notes to the kitchen, price, taxes, and fees. Menus, prices, availability, hours, and estimated times are set by the Restaurant and may change.

2.3 If you have a food allergy or dietary requirement, you are responsible for confirming suitability directly with the Restaurant. NoFee does not verify allergen or ingredient information.

2.4 Estimated pickup or delivery times and any "on-time" or badge indicators are informational and not guaranteed by NoFee. Delivery, where offered, is provided by the Restaurant using its own staff or couriers.

3. PAYMENTS, REFUNDS, AND DISPUTES

3.1 Order payments are processed through Stripe. By paying, you authorize the charge for your Order, including items, applicable taxes, and any delivery fee shown at checkout. You agree the price you see at checkout is what you pay, consistent with the Platform's "no hidden fees" representation.

3.2 Refunds. Because the Restaurant is the seller, refunds, cancellations, and remakes are handled according to the Restaurant's policy. If something is wrong with your Order, contact the Restaurant (and you may also contact NoFee support for help facilitating). Refunds, where due, are typically issued through the original payment method.

3.3 Disputes/chargebacks. If you have a problem, please seek a resolution with the Restaurant or NoFee support before disputing a charge with your bank. Fraudulent or bad-faith chargebacks may result in Account suspension.

4. COMMUNICATIONS AND YOUR PREFERENCES

4.1 During sign-up and in your settings, you choose how you receive ordering links, Order updates, and notifications — for example by email, SMS/text, or WhatsApp, and you can enable in-app and push notifications. You consent to receive transactional messages (such as Order confirmations, status updates, security and Account notices) through the channels associated with your Account.

4.2 Marketing messages (such as promotions, new-restaurant alerts, and Rewards updates) are sent only with the consent required by law, and you can opt out at any time — unsubscribe in emails, reply STOP to text messages (and HELP for help), or adjust your notification preferences. Message and data rates may apply. Opting out of marketing does not stop transactional messages needed to provide the service.

4.3 [[CONFIRM: ensure consent capture, sender identification, STOP/HELP, and 10DLC registration are implemented before relying on this section]]

5. REWARDS AND REFERRALS

5.1 If you participate in the Rewards program, your points, gift credits, and referrals are governed by the Rewards Program Terms. In summary, rewards have no cash value, are subject to eligibility and anti-fraud rules, and may be reviewed before redemption. Sharing and referral rewards require genuine activity; self-referrals, fake accounts, and manipulation are prohibited and may result in forfeiture and suspension.

6. ACCEPTABLE USE

6.1 You agree to use the Platform lawfully and in line with the acceptable-use rules in the Terms of Service. In particular, you will not:
(a) place fraudulent, fake, or bad-faith Orders, or use stolen or unauthorized payment methods;
(b) submit false or misleading reviews or Content, or impersonate others;
(c) abuse or manipulate Rewards, referrals, or promotions (including self-referrals, duplicate or fake accounts, or automated activity);
(d) harass, threaten, or abuse Restaurants, couriers, or NoFee staff; or
(e) interfere with, scrape, or attempt to gain unauthorized access to the Platform.

7. PRIVACY

7.1 Your personal information is handled as described in the Privacy Policy and Cookie Policy. When you place an Order, the Restaurant receives the information it needs to fulfill and communicate about your Order (such as your name, the contact detail for your chosen channel, and Order details). Restaurants use that information as independent controllers for fulfilling your Order.

8. DISCLAIMERS AND LIABILITY

8.1 The Platform is provided "as is." NoFee does not warrant the quality, safety, or availability of any food or the accuracy of menus, prices, or estimated times, which are the Restaurant's responsibility. The disclaimers and limitation of liability in the Terms of Service apply to you. Disputes about an Order are between you and the Restaurant.

9. CHANGES AND CONTACT

9.1 We may update this Customer Agreement as described in the Terms of Service. Continued use after the effective date is acceptance.

9.2 Questions or support requests can be sent to [[CONFIRM: customer support contact; footer shows support@nofee.restaurant]].
`;

const CustomerAgreement = () => (
 <LegalLayout title="Customer Agreement" lastUpdated="June 25, 2026">
 <LegalDocBody source={SOURCE} />
 </LegalLayout>
);

export default CustomerAgreement;
